import Swiper from 'swiper/swiper-bundle.min.mjs'
import 'swiper/swiper-bundle.css'

import BScroll from '@better-scroll/core'
import Scrollbar from '@better-scroll/scroll-bar'

BScroll.use(Scrollbar)

import { isMobile } from '@/utils/common.js'

export default {
  props: {
    characterData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      swiper: {},
      activeIndex: '',
      scrollbar: {},
      scrollTimeout: null,
    }
  },
  computed: {
    description: function () {
      return this.characterData[this.activeIndex] ? this.characterData[this.activeIndex].description : ''
    }
  },
  watch: {
    characterData: function(val) {
      if (val.length == 0) return

      this.initSwiper()
    },
    description: function (val) {
      if (Object.keys(this.scrollbar).length > 0) this.scrollbar.destroy()

      this.initScrollbar()
    }
  },
  methods: {
    // 初始化角色轮播图
    initSwiper() {
      this.$nextTick(() => {
        const self = this

        this.swiper = new Swiper('#characterSwiper', {
          direction: 'horizontal',
          loop: true,
          speed: 100,
          noSwiping: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination__btn',
            bulletActiveClass: 'swiper-pagination--active',
            type: 'custom',
          },
          on: {
            // 初始激活第一个轮播图的门和云的动画
            afterInit: function (swiper) {
              self.$refs['doorBox'].className = 'door-box animation'
              self.$refs['cloudBox'].className = 'cloud-box animation'
              self.activeIndex = swiper.activeIndex
            }
          }
        })

        // 轮播图切换开始时重置门和云的动画
        this.swiper.on('slideChangeTransitionStart', function () {
          self.$refs['doorBox'].className = 'door-box'
          self.$refs['cloudBox'].className = 'cloud-box'
        })
        // 轮播图切换结束后播放门和云的动画
        this.swiper.on('slideChangeTransitionEnd', function (swiper) {
          self.$refs['doorBox'].className = 'door-box animation'
          self.$refs['cloudBox'].className = 'cloud-box animation'
          self.activeIndex = swiper.activeIndex
        })
      })
    },
    initScrollbar() {
      if (isMobile()) {
        // 手机端
        this.$nextTick(() => {
          this.scrollTimeout = null
          if (Object.keys(this.scrollbar).length > 0) {
            this.scrollbar.stop()
            this.scrollbar.scrollTo(0, 0, 0)
          }
          this.scrollbar = new BScroll(this.$refs['textBox'], {
            click: true,
            scrollX: false,
            scrollY: true,
          })
          this.scrollTimeout = setTimeout(() => {
            const time = Math.abs(this.scrollbar.maxScrollY) / 10 * 1000
            this.scrollbar.scrollTo(0, this.scrollbar.maxScrollY, time)
          }, 1000)
        })
      } else {
        // PC端
        this.$nextTick(() => {
          this.scrollbar = new BScroll(this.$refs['scrollContent'], {
            click: true,
            scrollX: true,
            scrollY: false,
            scrollbar: {
              customElements: [this.$refs['horizontalScrollbar']],
              fade: false,
              interactive: true,
            }
          })
          this.scrollbar.scrollTo(1, 0, 0)
        })
      }
    }
  }
}